<template>
  <div class="role-page">
    <Button type="primary" icon="plus-round" v-if="permissionscheck === true" @click="edit(0)">{{$t("system.Role.New_Role")}}</Button>
    <Button type="primary" icon="plus-round" v-if="permissionscheck !== true" disabled>{{$t("system.Role.New_Role")}}</Button>
    <el-table class="account-table" highlight-row stripe border :data="datas">
      <el-table-column type="index" :label="$t('system.Role.index')" width="65px"></el-table-column>
      <el-table-column prop="name" :label="$t('system.Role.name')"></el-table-column>
      <el-table-column prop="Authorization" :label="$t('system.Role.Authorization')"></el-table-column>
      <el-table-column :label="$t('system.Role.operating')" width="150px">
        <template slot-scope="scope">
          <el-button v-if="permissionscheck === true" @click.native="edit(scope.row.id)" type="primary" size="small">{{$t('system.Role.edit')}}</el-button>
          <el-button v-if="permissionscheck === true" @click.native="remove(scope.row.id, scope.$index)" type="danger" size="small">{{$t('system.Role.delete')}}</el-button>
          <el-button v-if="permissionscheck !== true" type="primary" size="small" disabled>{{$t('system.Role.edit')}}</el-button>
          <el-button v-if="permissionscheck !== true" type="danger" size="small" disabled>{{$t('system.Role.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <Table class="role-table" highlight-row stripe border :columns="columns" :data="datas"></Table> -->
  </div>
</template>
<script>
import {Api} from '@/api'
import store from '@/store'
export default {
  name: 'Role',
  data () {
    return {
      // columns: [
      //   { type: 'index', title: this.$t('system.Role.index') },
      //   { title: this.$t('system.Role.name'), key: 'name' },
      //   { title: this.$t('system.Role.Authorization'), key: 'Authorization' },
      //   // {
      //   //   title: this.$t('system.Role.Authorization'),
      //   //   key: 'permissions',
      //   //   render: (h, params) => {
      //   //     let ps = []
      //   //     for (var v of params.row.permissions) {
      //   //       let per = this.permissions[v.action]
      //   //       if (per !== undefined) {
      //   //         ps.push(per + '-' + Api.permission.permissionValue(v.value))
      //   //       }
      //   //     }
      //   //     return h('span', ps.join())
      //   //   }
      //   // },
      //   {
      //     title: this.$t('system.Role.operating'),
      //     key: 'action',
      //     render: (h, params) => {
      //       if (this.permissionscheck === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('system.Role.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small'
      //             },
      //             on: {
      //               click: () => {
      //                 if (confirm(this.$t('system.Role.delete_message'))) {
      //                   this.remove(params.index)
      //                 }
      //               }
      //             }
      //           }, this.$t('system.Role.delete'))
      //         ])
      //       } else {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('system.Role.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small',
      //               disabled: true
      //             }
      //           }, this.$t('system.Role.delete'))
      //         ])
      //       }
      //     }
      //   }
      // ],
      datas: [],
      permissionscheck: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.permissions
    }
  },
  methods: {
    edit (id) {
      // let id = index === -1 ? 0 : this.datas[index].id
      this.$router.push({name: 'RoleEdit', params: { id }})
    },
    remove (id, index) {
      this.$api.role.delete(id).then(() => {
        this.datas.splice(index, 1)
      })
    }
  },
  mounted () {
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          this.permissionscheck = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    if (!store.getters.permissionsInited) {
      store.dispatch('InitPermissions')
    }
    Api.role.list().then(res => {
      next(vm => {
        vm.datas = res.roles
        let per = []
        per.super_admin = vm.$t('Permission.super_admin')
        per.system = vm.$t('Permission.system')
        per.device = vm.$t('Permission.device')
        per.card = vm.$t('Permission.card')
        per.people = vm.$t('Permission.people')
        per.product = vm.$t('Permission.product')
        per.order = vm.$t('Permission.order')
        per.production_plan = vm.$t('Permission.production_plan')
        per.monitor = vm.$t('Permission.monitor')
        per.report_export = vm.$t('Permission.report_export')
        for (let i = 0; i < vm.datas.length; i++) {
          vm.datas[i].Authorization = ''
          let c = false
          if (vm.datas[i].permissions !== undefined) {
            for (let j = 0; j < vm.datas[i].permissions.length; j++) {
              if (c === true) {
                vm.datas[i].Authorization += ','
              }
              vm.datas[i].Authorization += per[vm.datas[i].permissions[j].action] + '-'
              if (vm.datas[i].permissions[j].value === 1) {
                vm.datas[i].Authorization += vm.$t('Permission.R')
              } else if (vm.datas[i].permissions[j].value === 2) {
                vm.datas[i].Authorization += vm.$t('Permission.W')
              } else {
                vm.datas[i].Authorization += vm.$t('Permission.RW')
              }
              c = true
            }
          }
        }
      })
    })
  }
}
</script>
<style scoped>
.role-page {
  padding: 10px;
}

.role-table {
  margin-top: 20px;
}
</style>





// WEBPACK FOOTER //
// Role.vue?2b44b068